import { TEASERS } from "@/const/teaser.constants"
import { getDateInFormat, MONTH_YEAR } from "@/helpers/date.helpers"
import { useScopesPresentation } from "@/hooks/useScopesPresentation"
import { useTranslation } from "@/hooks/useTranslation"
import { ageOpenIssuesSelector } from "@/pages/DashboardPage/applications/useAgeOpenIssues.selector"
import {
  getInsightDefaultFilters,
  useStatisticsDashboard
} from "@/pages/DashboardPage/applications/useStatistics"
import { EmptyWidget } from "@/pages/DashboardPage/components/molecules/EmptyWidget"
import { FilterTitleCard } from "@/pages/DashboardPage/components/molecules/FilterTitleCard"
import CardDashboardTemplate from "@/pages/DashboardPage/components/templates/CardDashboardTemplate"
import { AgeOpenIssueChart } from "./AgeOpenIssueChart"

import type { AgeOpenResponse } from "@/api/useStatistics.types"

export const AgeOpenIssueWidget = () => {
  const { t } = useTranslation()
  const { t: tWidget } = useTranslation("translation", {
    keyPrefix: "dashboard.ageOpenIssueWidget"
  })
  const [{ response, isLoading }, state, actions] = useStatisticsDashboard<
    AgeOpenResponse,
    ReturnType<typeof ageOpenIssuesSelector>
  >(
    {
      needle: "/widgets/age-of-open-issues",
      defaultFilter: getInsightDefaultFilters()
    },
    { select: ageOpenIssuesSelector }
  )

  const {
    bySeverity: data = [],
    totalIssuesInScope,
    totalFilteredIssues,
    maxBySeverity = 0
  } = response?.data || {}

  const { isAllResourceScope } = useScopesPresentation()

  return (
    <CardDashboardTemplate
      noOverflow
      capitalize={false}
      loading={isLoading}
      title={tWidget("title")}
      subTitle={t("dashboard.discoveredSince", {
        date: state[0].since ? getDateInFormat(state[0].since, MONTH_YEAR) : ""
      })}
      contentPopover={tWidget("tooltip")}
      aside={
        <FilterTitleCard
          loading={isLoading}
          count={totalFilteredIssues}
          total={totalIssuesInScope}
          values={state[0]}
          onOk={state[1]}
        />
      }
      teasers={{
        dataReadiness: true,
        scmInstalled: TEASERS.SCM_INSTALLED.codeRepoNotConnected(t)
      }}
    >
      <EmptyWidget
        text={t("dashboard.empty.noIssues.ageOpen")}
        count={totalFilteredIssues}
        total={totalIssuesInScope}
        shouldHideScanProgressEmptyTable={!isAllResourceScope}
      >
        <AgeOpenIssueChart
          data={data}
          max={maxBySeverity}
          redirectToTriage={actions.redirectToTriage}
        />
      </EmptyWidget>
    </CardDashboardTemplate>
  )
}
